/**
 * @generated SignedSource<<d490bfe40e310017fa9a344af6cabb96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPriceDisplay_item$data = {
  readonly skus: ReadonlyArray<{
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"PriceDisplay_sku">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedEstimateValueBadge_item" | "PdpSharedFramingStatus_item" | "PriceDisplayBot_item" | "PriceDisplay_item">;
  readonly " $fragmentType": "PdpSharedPriceDisplay_item";
};
export type PdpSharedPriceDisplay_item$key = {
  readonly " $data"?: PdpSharedPriceDisplay_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPriceDisplay_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "catchNonFatalErrors",
  "value": false
},
v1 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v2 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v3 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v4 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplayOrBtSsr"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPriceDisplay_item",
  "selections": [
    {
      "condition": "afterDisplayOrBtSsr",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFramingStatus_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PriceDisplayBot_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedEstimateValueBadge_item"
        },
        {
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "kind": "FragmentSpread",
          "name": "PriceDisplay_item"
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "condition": "isMultiSku",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "hasSkuId",
                  "value": true
                },
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "PriceDisplay_sku"
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "33e613be11ada0ced5c7b37bbe77b00d";

export default node;
